import { municipalFlatForm } from "modules/ebiForms/definitions/sharedHousing";
import { EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * A10. Wniosek o wynajem mieszkania komunalnego lub socjalnego z zasobu gminy — art. 4 i art. 20–23 ustawy z 21.06.2001 r.
 * o ochronie praw lokatorów, mieszkaniowym zasobie gminy i o zmianie Kodeksu cywilnego (art. 21b — deklaracja o dochodach,
 * oświadczenie majątkowe i o braku tytułu do innego lokalu), uchwała rady gminy o zasadach wynajmowania. Definicja wspólna
 * z E1 (ta sama procedura w jednostce zarządzającej zasobem): municipalFlatForm w sharedHousing.ts — wzory Gdańska
 * i Rudy Śląskiej (pobrane 22.10.2026). Sprawa cywilnoprawna, bez decyzji; nabór i kryteria — do potwierdzenia z wydziałem.
 */
const A10: IEbiFormDefinition = municipalFlatForm({
  code: "A10",
  office: EEbiFormOffice.Municipality,
  organ: "Wójt / Burmistrz / Prezydent Miasta (wydział mieszkalnictwa)",
  title: "Wniosek o najem lokalu mieszkalnego lub socjalnego z zasobu gminy",
  description: "Najem mieszkania komunalnego albo socjalnego — wniosek z deklaracją o dochodach i oświadczeniami gospodarstwa domowego.",
  request: "Wnoszę o zawarcie umowy najmu lokalu z mieszkaniowego zasobu gminy w zakresie wskazanym we wniosku.",
});

export default A10;
